<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">About IQAC</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">About IQAC</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100 ">
  <div class="container">
    <div class="row justify-content-center gx-4">
      <div class="col-md-12">
        <p>The IQAC is functional in planning and implementation of the infrastructural and the academic upgrade of the
          College within the ambits of UGC guidelines. It takes into account each teacher's performance in both
          curricular and extra-curricular areas for their career advancement.</p>
        <p>With its objective of sustenance and enhancement of quality education, the major thrust areas are student
          enrolment, student participation, motivation, quality improvement, promotion of quality research culture,
          enhancement of infrastructural facilities and support services. With the Principal as Chairperson, meetings
          are conducted periodically to discuss issues relating to academic performance and non-academic matters of the
          college to foster efficient organization and maintenance of credentials pertaining to the staff and students.
        </p>
        <p>The IQAC assists the College authorities in formulating various action plans and strategies to increase the
          institution’s performance by carefully assessing its strengths, weaknesses, challenges and opportunities. The
          Cell organizes various programmes and seminars/workshops for the benefit of teaching and non-teaching staff.
        </p>
      </div>
    </div>
  </div>
</section>
